import { frame, maskimg } from "assets";
import styled from "styled-components";

export const MainSection = styled.section`
  /* @media (max-width: 990px) {
    .carddiv {
      display: none;
    }
  }

  @media (min-width: 990px) {
    .mobile-carddiv {
      display: none;
    }
  } */

  .main-div {
    padding-bottom: 8rem;
    @media (max-width: 990px) {
      padding-bottom: 4rem;
    }
  }
`;

export const TextBoxDiv = styled.div`
  margin-top: 4rem;
  position: relative;
  width: 37.5625rem;
  height: 5.5rem;

  @media (max-width: 1600px) {
    width: 25.5625rem;
  }

  @media (max-width: 600px) {
    width: 300px;
    margin-top: 1rem;
  }

  img {
    width: 100% !important;
    height: 100% !important;
  }

  div {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: end;
    align-items: center;
    padding-right: 3rem;
    h1 {
      margin: 0;
      color: #fff;
      font-size: 50px;
      font-style: italic;
      font-weight: 400;
      line-height: 77.247px; /* 154.494% */
      letter-spacing: -1px;

      @media (max-width: 1600px) {
        font-size: 2.125rem;
      }
      @media (max-width: 767px) {
        font-size: 1.74063rem;
      }

      span {
        font-family: "Space Crusaders" !important;
        color: #f7c13a;
      }
    }
  }
`;

export const CardWrapper = styled.div`
  position: relative;
  width: 371px;
  height: 543.5px;
  margin-top: 3rem;

  @media (max-width: 400px) {
    width: 100%;
  }

  .innerimg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
  }
`;

export const MobileCardWrapper = styled.div`
  position: relative;
  width: 100%;
  margin-top: 3rem;
  padding-bottom: 2rem;
  height: 463.5px;

  .innerimg {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }
`;

export const CardInnerDiv = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  padding: 1rem 1.7rem;

  .mask1 {
    -webkit-mask-image: url(${frame});
    mask-image: url(${frame});
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
  }
`;

export const TextDiv = styled.div`
  margin-top: 1rem;

  .inner-div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1rem;
  }

  h2 {
    text-align: start;
    margin: 0;
  }

  .img-div {
    display: flex;
    gap: 0.7rem;
    align-items: center;
  }

  .content-div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 0.7rem;
    h5 {
      color: #8e8c8c;
      font-family: "Inter" !important;
      font-size: 16.444px;
      font-style: italic;
      font-weight: 500;
      line-height: normal;
      margin: 0;
    }

    p {
      text-align: right;
      font-family: "Inter" !important;
      font-size: 16.444px;
      font-style: italic;
      font-weight: 600;
      line-height: normal;
      background: var(
        --yellow,
        linear-gradient(180deg, #e0c528 0%, #f7c13a 100%)
      );
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      margin: 0;
    }
  }
`;

export const Name = styled.h1`
  color: #e9c42f;
  font-size: 20px;
  font-style: italic;
  font-weight: 400;
  line-height: normal;
  padding-bottom: 0.5rem;
  @media (max-width: 1450px) {
    font-size: 14px;
  }
`;

export const LastText = styled.p`
  color: #fff;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 77.247px; /* 321.862% */
  letter-spacing: 0.96px;
  text-align: end;
`;

export const Message = styled.h5`
  color: #fff;
  text-align: center;
  text-shadow: 0px 1.122px 1.122px rgba(0, 0, 0, 0.9);
  font-size: 2.54519rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
  margin-top: 8rem;

  @media (max-width: 990px) {
    margin-top: 10rem;
    font-size: 1.54519rem;
  }

  span {
    color: #edc332;
    font-size: 2.54519rem;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: uppercase;

    @media (max-width: 990px) {
      font-size: 1.54519rem;
    }
  }
`;

export const MessageDiv = styled.div`
  p {
    color: #fff;
    text-align: center;
    text-shadow: 0px 1.122px 1.122px rgba(0, 0, 0, 0.9);
    font-size: 2.54519rem;
    font-style: normal;
    font-weight: 600;
    line-height: normal;

    margin-top: 8rem;

    @media (max-width: 990px) {
      margin-top: 10rem;
      font-size: 1.54519rem;
    }
  }

  .register-btn-div {
    cursor: pointer;
    position: relative;
    width: 215px;
    height: 46px;
    display: block;
    margin-left: auto;
    margin-right: auto;
    h1 {
      font-size: 16px;
      font-style: italic;
      font-weight: 400;
      line-height: 19px;
      letter-spacing: 0em;
      color: rgba(51, 29, 1, 1);
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      width: 100%;
    }

    .btn-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
`;
